import { pipe } from "fp-ts/lib/function";
import * as Either from "fp-ts/Either";
import { UnsupportedProtocolInstanceError } from "./types";
import { ProtocolInstance, isFeatureProtocolInstance } from "@silo/types";

export const graphProtocolInstance = (protocolInstance: ProtocolInstance) =>
  pipe(
    protocolInstance,
    Either.of,
    Either.filterOrElse(
      isFeatureProtocolInstance("graph"),
      (): UnsupportedProtocolInstanceError => ({
        _tag: "UnsupportedProtocolInstanceError",
        protocolInstance,
      })
    )
  );
